import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {QuestionInput} from '../question-input';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent extends QuestionInput implements OnInit {

  @ViewChild('dateStart', {static: true})
  dateStart: ElementRef;
  @ViewChild('dateEnd', {static: true})
  dateEnd: ElementRef;
  value: { dateStart: Date; dateEnd: Date };

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.question.answer && this.question.answer.answer) {
      this.value = JSON.parse(this.question.answer.answer);
      this.value.dateStart = new Date(this.value.dateStart);
      this.value.dateEnd = new Date(this.value.dateEnd);
    }
  }

  get answer(): any {
    return JSON.stringify({dateStart: this.dateStart.nativeElement.value, dateEnd: this.dateEnd.nativeElement.value});
  }

  valueChange($event) {
    this.questionAnswered.emit(this.dateStart.nativeElement.value && this.dateEnd.nativeElement.value);

    $event.target._elementRef.nativeElement.classList.add('is-selected');
  }

  getMaxDate() {
    const currentDate = new Date();
    return new Date(currentDate.setFullYear(new Date().getFullYear() + 1));
  }
}
